module.exports = __webpack_public_path__ + "img/flex5_5-back.cf04c8d4.jpg";